<div class="account-pages"></div>
<div class="clearfix"></div>
<div class="wrapper-page">
	<div class="card-box">
		<div class="panel-heading text-center">
			<img src="/style/logo/1" alt="" style="width: 100%;"></img>
			{{#if locked}}
				<div id="ct-unknown-user" class="alert alert-danger m-t-20">{{TR 'Ihr Konto wurde gesperrt. Sie erhalten eine E-Mail mit einem Link, mit dem Sie Ihr Passwort zurücksetzen können.'}}</div>
			{{/if}}
		</div>
		<div class="panel-body">
			<form class="form-horizontal" action="#" method="post">
				<div class="form-group">
					<div class="col-xs-12">
						<input id="js-email-input" class="form-control {{#if errors.email}}parsley-error{{/if}}" type="email" name="username" placeholder="{{TR "E-Mail"}}" value="{{username}}" disabled>
					</div>
				</div>
				<div class="form-group">
					<div class="col-xs-12">
						{{TR 'Bitte geben Sie den in der Authentifizierungs-App angezeigten Zahlencode ein.'}}
					</div>
				</div>
				<div class="form-group">
					<div class="col-xs-12">
						<input id="js-code-input" class="form-control {{#if errors.error}}parsley-error{{/if}}" type="text" name="code" placeholder="{{TR "2FA Code"}}" autofocus {{#if locked}}disabled{{/if}}>
						{{#if errors.error}}
			            <ul class="parsley-errors-list filled">
			                <li class="parsley-required">{{TR errors.error}}</li>
			            </ul>
			            {{/if}}
					</div>
				</div>

				<div class="form-group text-center m-t-40">
					<div class="col-xs-12">
						<button id="js-login-btn" class="js-login btn btn-pink btn-block text-uppercase" type="submit" {{#if locked}}disabled{{/if}}>
							{{TR "Authentifizieren"}}
						</button>
					</div>
				</div>
				<div class="form-group m-t-30 m-b-0">
					<div class="col-xs-12">
						<div class="js-lang-menu pull-right" data-toggle="popover" data-html="true" data-content="{{TR_SELECTOR}}">
							{{TR 'Sprache'}}: <strong>{{lang}}</strong> <span class="caret"></span>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
	<div class="row">
		<div class="col-sm-12 text-center">
			<p>
				{{TR "Um die Funktionsfähigkeit der Anwendung sicherzustellen verwendet diese Webseite Cookies."}}<br>
				<a href="#" id="js-gdpr">{{TR "Datenschutzhinweis"}}</a>
			</p>
		</div>
	</div>
</div>

{{> PARTIAL_FOOTER}}
